import NewsArchive from './NewsArchive';
export const basePath = "/news";
export const path = `${basePath}/:articleId?`;
export const newsArchiveRoute = { path: path, component: NewsArchive }
